var React = require('react');

function ArrowHead (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill: #fff;\n      }\n    ")),React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1","key":1},React.createElement("path",{"className":"cls-1","d":"m11.34,36.92c-.34-.34-.88-.34-1.22,0l-3.46,3.47V.87c0-.48-.39-.87-.87-.87h0c-.48,0-.87.39-.87.87v39.51l-3.46-3.46c-.34-.34-.88-.34-1.22,0-.34.34-.34.88,0,1.22l4.76,4.76c.43.43,1.14.43,1.57,0l4.76-4.76c.34-.34.34-.88,0-1.22Z"}))]);
}

ArrowHead.defaultProps = {"id":"Layer_2","data-name":"Layer 2","viewBox":"0 0 11.6 43.23"};

module.exports = ArrowHead;

ArrowHead.default = ArrowHead;
